import * as React from 'react';
import { connect } from 'react-redux';
import { SwordSearch } from 'src/app/Partials';
import { GroupsDispatcher } from 'src/app/Container';
import { GlobalPrivateState, plateBuilder, warnings } from 'src/api';
import { requestAPIActions } from 'loopback-react-request';

import './FolderList.page.scss';
import TroughBanner from 'src/app/Partials/TroughBanner/TroughBanner';
import FolderList from 'src/app/Partials/Configuration/List/FolderList';
import FolderSwitchView from 'src/app/Partials/Configuration/SwitchView/FolderSwitchView';
import FolderListHeadered from 'src/app/Partials/Configuration/List/FolderListHeadered';

export interface FolderListPageProps {
  checkout: GlobalPrivateState['checkout'];
  groups: GlobalPrivateState['groups'];
  trough: GlobalPrivateState['trough'];
  troughs: GlobalPrivateState['troughs'];
  order: GlobalPrivateState['order'];
  dispatch: Function;
}

export class FolderListPageComponent extends React.Component<FolderListPageProps> {

  componentWillUnmount() {
    this.props.dispatch(requestAPIActions.loadCleared('folders'));
  }

  public render() {
    return (
      <div className="page-configurations">
        <GroupsDispatcher />
        <div className="page-configuration-list pb-3">
          <div className="container">
            <div style={{visibility: 'hidden'}}><SwordSearch /></div>
            <div className="view-switcher">
              <FolderSwitchView />
            </div>
            <FolderListHeadered />
          </div>
        </div>
      </div>
    );
  }
}

export const FolderListPage = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  groups: state.groups,
  trough: state.trough,
  troughs: state.troughs,
  order: state.order,
}))(FolderListPageComponent);